import { Component, NgModule, Type } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { environment } from 'src/environments/environment';
import { HomeComponent } from './home/home.component';
import { LoginComponent } from './login/login.component';

const routes: Routes = [
  {
    path: "home",
    component: getHomeComponent()
  },
  {
    path: "login",
    component: LoginComponent
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AuthRoutingModule { }


export function getHomeComponent(): Type<Component> {

  if (environment.host.newHomePage) {
    return <Type<Component>>HomeComponent;
  } else {
    return <Type<Component>>HomeComponent;
  }


}